import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrash, faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';

const IUUsers = () => {
    const navigate = useNavigate();
    const [usersData, setUsersData] = useState([]);
    const [deleteCode, setDeleteCode] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            const result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/iuusersmapping/getUsersMapDatabyUserCode`, {
                "userCode": localStorage.getItem("userCodeGlobal")
            });
            setUsersData(result.data.dataContent);
          
        };
        fetchData();
    }, []);

    function viewData(value) {
       
        var x = document.createElement("a")
        x.id = "mpopupLink";
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "block";


        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "UserCode": String(value.userCode),
            "IUUserMappingCode": String(value.iuUserMappingCode)
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/iuusersmapping/getIUUserMappingAllByUserCode`, requestOptions)
            .then(response => response.json())
            .then(result => {
                // let userData = result.success;
               
                if(result.success === true){
            
                    viewDetailsGrid(result.dataContent, value)

                }

                // document.getElementById("modal-content").innerHTML = '<div class="row iuusermappings"> <div class="col-md-4"> <h6>IU Name</h6> <p>' + userData.iuName + '</p> </div> <div class="col-md-4"> <h6>State</h6> <p>' + userData.stateName + '</p> </div> <div class="col-md-4"> <h6>District</h6> <p>' + userData.districtName + '</p> </div> <div class="col-md-4"> <h6>IU Level</h6> <p>' + userData.iuLevel + '</p> </div> <div class="col-md-4"> <h6>User Name</h6> <p>' + userData.userName + '</p> </div> <div class="col-md-4"> <h6>User Mobile No.</h6> <p>' + userData.userMobile + '</p> </div> <div class="col-md-4"> <h6>Crop Name</h6> <p>' + userData.cropName + '</p> </div> <div class="col-md-4"> <h6>Block </h6> <p>' + userData.blockName + '</p> </div> <div class="col-md-4"> <h6>Village Name</h6> <p>' + userData.villageName + '</p> </div> </div>';
            })
            .catch(error => console.log('error', error));


    }

    function viewDetailsGrid(value, personalData) {
    
        let orgLevelLocal ;
        if(personalData.iuUserType === "G") {
            orgLevelLocal = "Government"
        }else {
            orgLevelLocal = "Insurance"
        }
        let htmlData = '';
        htmlData =  '<div class="row"> <div class="col-md-4"> <h6>User Name</h6> <p>' + personalData.userName + '</p> </div>  <div class="col-md-4"> <h6>Mobile No.</h6> <p>' + personalData.userMobile + '</p> </div><div class="col-md-4"> <h6>Created Date (yy-mm-dd)</h6> <p>' + personalData.createdOnByUC.split("T")[0] + '</p> </div> <div class="col-md-4"> <h6>Organization Level</h6> <p>' + orgLevelLocal + '</p> </div> </div> '+ '<table class="table table-bordered datatable" style={{marginTop: "35px"}}> <thead style={{backgroundColor: "lightgrey"}}> <tr>  <th scope="col">Crop Name</th>  <th scope="col">District Name</th>   <th scope="col">Level4</th> <th scope="col">Level5</th>  <th scope="col">Level6</th> <th scope="col">Vilage</th>  <th scope="col">Insurance Company Name</th> <th scope="col">Notified IU Name</th> </tr>  </thead>   <tbody>'


        let htmlSubData = value.map((item, index) => {
            return  '<tr key=' +index +'>'+
             '<th >'+item.cropName + '</th>'+
             '<td >'+item.districtName +'</td>'+
             '<td >'+item.level4Name +'</td>'+
             '<td >'+item.level5Name +'</td>'+
             '<td >'+item.level6Name +'</td>'+
             '<td >'+item.villageName +'</td>'+
             '<td >'+item.insuranceCompanyName +'</td>'+
             '<td >'+item.notifiedIUName +'</td></tr>'      
          }).join('')      
          
        

document.getElementById("modal-content").innerHTML = htmlData + htmlSubData +  '</tbody></table>'
console.log("htmlData", htmlData)
    }


    function removed() {
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "none";

    }

    function deleteData(value) {
      
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify(deleteCode);

        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/iuusersmapping`, requestOptions)
            .then(response => response.text())
            .then(result => {
                if (JSON.parse(result).success == true) {
                    fetchData2()

                }
            })
            .catch(error => console.log('error', error));
    }

    async function fetchData2() {
        const result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/iuusersmapping/getUsersMapDatabyUserCode`, {
            "userCode": localStorage.getItem("userCodeGlobal")
        });
        setUsersData(result.data.dataContent);
    }

    function formatData(originalRow) {
        if(originalRow.iuUserType === "G") {
            return "Government"
        }else {
            return "Insurance"
        }

    }

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
          
         
            {
                accessorKey: 'userName',
                header: 'User Name',
            },
            {
                header: 'IU User Type',
                accessorFn: (originalRow) => formatData(originalRow), //alternative to accessorKey, using accessorFn
                id: 'iuUserType',
            },
            {
                accessorKey: 'mapYear',
                header: 'Year', 
            },
           
            {
                accessor: '',
                header: 'Actions',
                Cell: cell => <><i className="btn text-success" type="button" onClick={(e) => viewData(cell.row.original)}> <FontAwesomeIcon icon={faEye} /></i>
                    <i className="btn text-primary" type="button" onClick={() => navigate("/usermanagement/iuusermapping/addnewiu", { state: { IUCode : cell.row.original } })}><FontAwesomeIcon icon={faPencil} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop_IU" onClick={() => setDeleteCode({ "IUUserMappingCode": cell.row.original.iuUserMappingCode, "UserCode": cell.row.original.userCode})}> <FontAwesomeIcon icon={faTrashAlt} /></i></>

            },
       
        ],
       
        [],
    );

    return (
        <>
          
            <main id="main" className="main">
                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">

                    <nav>
                        <h1>IU User Mapping</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">User Management</li>
                            <li className="breadcrumb-item active">Add New Mapping</li>
                        </ol>
                    </nav>
                    <button type="button" className="btn btn-success" onClick={() => navigate("/usermanagement/iuusermapping/addnewiu")}>Add New</button>
                </div>
                <section className="section">

                    <div className="row justify-content-lg-center">
                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={usersData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                />
                            </div>

                        </div>

                        <div className="col-lg-6">

                        </div>
                    </div>
                </section>
            </main>

            <div className="modal fade" id="staticBackdrop_IU" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="deleteLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                        </div>
                        <div className="modal-body">
                            <h6 id="deleteHeading">Are you sure you want to delete this item?</h6>


                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={deleteData}>Yes</button>
                            <button type="button" className="btn border" data-bs-dismiss="modal">No</button>

                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade viewDetails" id="viewDetails" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="viewDetailsLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="viewDetailsLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                        </div>
                        <div className="modal-body" id="modal-body">

                        </div>
                        <div className="modal-footer">
                           
                        </div>
                    </div>
                </div>
            </div>

            <div id="mpopupBox" className="modal viewDetailsIUUser">

                <div className="modal-content" >
                    <div className="modal-header">
                        <h2>View Details</h2>
                        <button type="button" className="btn-close" onClick={removed}>X</button>
                    </div>
                    <div className="madal-body" id="modal-content" >



                    </div>
                    <div className="modal-footer">

                    </div>
                </div>

            </div>

        </>
    )
}

export default IUUsers;